import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { FontIcon } from 'react-md';

import I18nMarkdown from '../../../Common/i18nMarkdown';

const Part = ({
  title,
  show,
  remove,
  setShowPartie,
  displayTitle,
  showHelp,
  help,
  setShowHelperPart,
  children,
  showLabel,
}) => {
  // remove this part ?
  if (remove) {
    return <span />;
  }

  const head = () =>
    displayTitle ? (
      <div className="head">
        <FontIcon className={cn({ show, hide: !show })}>change_history</FontIcon>
        <span role="presentation" onClick={setShowPartie} className="title">
          {title}
        </span>
      </div>
    ) : (
      []
    );

  const helper = () =>
    help ? (
      <div className="help">
        <div className="head" role="button" tabIndex="0" onKeyDown={setShowHelperPart} onClick={setShowHelperPart}>
          {showLabel}
        </div>
        {showHelp && (
          <div className="body">
            <I18nMarkdown string={help} defaultValue={help} />
          </div>
        )}
      </div>
    ) : (
      []
    );

  return (
    <div className="part">
      {head()}
      {helper()}
      <div className={cn('group', { show: show, hide: !show })}>{children}</div>
    </div>
  );
};

Part.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  remove: PropTypes.bool,
  setShowPartie: PropTypes.func.isRequired,
  showHelp: PropTypes.bool,
  setShowHelperPart: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  displayTitle: PropTypes.bool,
  help: PropTypes.string,
  showLabel: PropTypes.string,
};
Part.defaultProps = {
  title: '',
  remove: false,
  displayTitle: true,
  showHelp: false,
  help: '',
  showLabel: 'En savoir plus...',
};

export default Part;
